// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function isValidEnumValue<T>(en: Record<string, T>, val: T): boolean {
  return !!val && Object.values(en).includes(val);
}
